import Radio from 'style-guide/Radio';
import theme from 'style-guide/Theme';
import Text from 'style-guide/Typography/Text';

const LikertScaleAnswer = ({ answer }) => (
  <div className='d-flex justify-content-center likert-scale-block organizer-card'>
    {answer.map((item) => (
      <Radio className='likert-scale mr--40 mt--16' key={item.id} disabled>
        <Text $variant={2} className='mb--16' color={theme().colors.dark[60]}>
          {item.answer}
        </Text>
      </Radio>
    ))}
  </div>
);

export default LikertScaleAnswer;
